import { ref, watch } from 'vue'
import { formatDateForInput } from '../utils/dateUtils'

const getInitialStartDate = () => {
  return formatDateForInput(new Date(new Date().setHours(0,0,0,0)))
}

const getInitialEndDate = () => {
  return formatDateForInput(new Date(new Date().setHours(23,59,0,0)))
}

const getInitialActiveTab = () => {
  const savedTab = localStorage.getItem('activeTab')
  if (savedTab && ['substances', 'journal', 'my-substances', 'insights', 'goals'].includes(savedTab)) {
    return savedTab
  }
  return 'substances'
}

// Create singleton store instance
const startDate = ref<string>(getInitialStartDate())
const endDate = ref<string>(getInitialEndDate())
const activeTab = ref<string>(getInitialActiveTab())

// Watch for changes in date range and save to localStorage
watch([startDate, endDate], async ([newStartDate, newEndDate]) => {
  localStorage.setItem('startDate', newStartDate)
  localStorage.setItem('endDate', newEndDate)
}, { immediate: true })

// Watch for changes in active tab and save to localStorage
watch(activeTab, (newTab) => {
  localStorage.setItem('activeTab', newTab)
}, { immediate: true })

const goToPreviousDay = () => {
  const start = new Date(startDate.value);
  const end = new Date(endDate.value);
  start.setDate(start.getDate() - 1);
  end.setDate(end.getDate() - 1);
  startDate.value = formatDateForInput(start);
  endDate.value = formatDateForInput(end);
}

const goToNextDay = () => {
  const start = new Date(startDate.value);
  const end = new Date(endDate.value);
  start.setDate(start.getDate() + 1);
  end.setDate(end.getDate() + 1);
  startDate.value = formatDateForInput(start);
  endDate.value = formatDateForInput(end);
}

const updateDateRange = (newStartDate: string, newEndDate: string) => {
  startDate.value = newStartDate
  endDate.value = newEndDate
}

const updateActiveTab = (newTab: string) => {
  activeTab.value = newTab
}

export const useDateRangeStore = () => {
  return {
    startDate,
    endDate,
    activeTab,
    goToPreviousDay,
    goToNextDay,
    updateDateRange,
    updateActiveTab
  }
} 